import { render, staticRenderFns } from "./VouchersReload.vue?vue&type=template&id=4b1939c9&"
import script from "./VouchersReload.vue?vue&type=script&lang=js&"
export * from "./VouchersReload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b1939c9')) {
      api.createRecord('4b1939c9', component.options)
    } else {
      api.reload('4b1939c9', component.options)
    }
    module.hot.accept("./VouchersReload.vue?vue&type=template&id=4b1939c9&", function () {
      api.rerender('4b1939c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/VouchersReload.vue"
export default component.exports